module.exports = __webpack_public_path__ + "8dd35fcae69c50a11428ee69a529a1e0.pdf";